// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,json_types=true"
// @generated from file creativefabrica/studioagent/v1/types.proto (package creativefabrica.studioagent.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Surface, SurfaceJson } from "@repo/rpc-types-creativefabrica-common-v1/surface/v1";
import { file_creativefabrica_common_v1_surface_v1_types } from "@repo/rpc-types-creativefabrica-common-v1/surface/v1";
import type { Error, ErrorJson } from "../../errors/v1/types_pb";
import { file_creativefabrica_errors_v1_types } from "../../errors/v1/types_pb";
import type { Generation, GenerationError, GenerationErrorJson, GenerationJson, MediaType, MediaTypeJson, OutputMedia, OutputMediaJson } from "@repo/rpc-types-creativefabrica-modality-v1";
import { file_creativefabrica_modality_v1_types } from "@repo/rpc-types-creativefabrica-modality-v1";
import type { FieldValue, FieldValueJson, Modality, ModalityJson } from "@repo/rpc-types-creativefabrica-preset-v1";
import { file_creativefabrica_preset_v1_types } from "@repo/rpc-types-creativefabrica-preset-v1";
import type { Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message as Message$1 } from "@bufbuild/protobuf";

/**
 * Describes the file creativefabrica/studioagent/v1/types.proto.
 */
export const file_creativefabrica_studioagent_v1_types: GenFile = /*@__PURE__*/
  fileDesc("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", [file_creativefabrica_common_v1_surface_v1_types, file_creativefabrica_errors_v1_types, file_creativefabrica_modality_v1_types, file_creativefabrica_preset_v1_types, file_google_protobuf_timestamp]);

/**
 * Usage is the per-turn resource accounting.
 *
 * @generated from message creativefabrica.studioagent.v1.Usage
 */
export type Usage = Message$1<"creativefabrica.studioagent.v1.Usage"> & {
  /**
   * @generated from field: int64 input_tokens = 1;
   */
  inputTokens: bigint;

  /**
   * @generated from field: int64 output_tokens = 2;
   */
  outputTokens: bigint;

  /**
   * @generated from field: int64 cache_read_tokens = 3;
   */
  cacheReadTokens: bigint;

  /**
   * @generated from field: int64 cache_write_tokens = 4;
   */
  cacheWriteTokens: bigint;

  /**
   * @generated from field: int64 coins = 5;
   */
  coins: bigint;
};

/**
 * Usage is the per-turn resource accounting.
 *
 * @generated from message creativefabrica.studioagent.v1.Usage
 */
export type UsageJson = {
  /**
   * @generated from field: int64 input_tokens = 1;
   */
  inputTokens?: string;

  /**
   * @generated from field: int64 output_tokens = 2;
   */
  outputTokens?: string;

  /**
   * @generated from field: int64 cache_read_tokens = 3;
   */
  cacheReadTokens?: string;

  /**
   * @generated from field: int64 cache_write_tokens = 4;
   */
  cacheWriteTokens?: string;

  /**
   * @generated from field: int64 coins = 5;
   */
  coins?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.Usage.
 * Use `create(UsageSchema)` to create a new message.
 */
export const UsageSchema: GenMessage<Usage, {jsonType: UsageJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 0);

/**
 * Message is a single turn in a conversation.
 *
 * @generated from message creativefabrica.studioagent.v1.Message
 */
export type Message = Message$1<"creativefabrica.studioagent.v1.Message"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.MessageRole role = 2;
   */
  role: MessageRole;

  /**
   * @generated from field: string text = 3;
   */
  text: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.MessageStatus status = 4;
   */
  status: MessageStatus;

  /**
   * @generated from field: creativefabrica.studioagent.v1.Usage usage = 5;
   */
  usage?: Usage | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp | undefined;

  /**
   * tool_events summarizes the tool calls the assistant made while producing
   * this message (generation-capable agents only; empty for pure chat).
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.ToolEvent tool_events = 7;
   */
  toolEvents: ToolEvent[];

  /**
   * type marks media-generation messages so clients render them as media
   * instead of a chat bubble.
   *
   * @generated from field: creativefabrica.studioagent.v1.MessageType type = 8;
   */
  type: MessageType;

  /**
   * generation is the media generation attached to this message — set only on
   * type=media messages, carrying status, outputs, error and timestamps
   * inline, so a transcript renders media without extra calls or joins.
   *
   * @generated from field: creativefabrica.modality.v1.Generation generation = 9;
   */
  generation?: Generation | undefined;

  /**
   * action is set on a completed assistant message that requires an explicit
   * user decision before the described work may begin.
   *
   * @generated from field: creativefabrica.studioagent.v1.MessageAction action = 10;
   */
  action?: MessageAction | undefined;

  /**
   * attachments are the reusable conversation inputs attached to this turn.
   * Their preview URLs are short-lived and may change between reads.
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.MessageAttachment attachments = 11;
   */
  attachments: MessageAttachment[];

  /**
   * expression is the single visual reaction cue the agent chose for this
   * assistant message (one of Agent.expression_cues). UNSPECIFIED for a
   * neutral reply, for user messages, for agents without a registry, and for
   * messages persisted before this field. Clients map the cue onto their own
   * mascot animation set and treat unknown values as neutral.
   *
   * @generated from field: creativefabrica.studioagent.v1.ExpressionCue expression = 12;
   */
  expression: ExpressionCue;

  /**
   * thoughts are the model's own reasoning summaries for this assistant turn,
   * one entry per model round in order, when the provider returns them.
   * Product-facing text, not a transcript of tool calls (see tool_events).
   * Empty when the provider or agent does not produce them.
   *
   * @generated from field: repeated string thoughts = 13;
   */
  thoughts: string[];

  /**
   * failure explains a chat turn that ended in MESSAGE_STATUS_FAILED, using
   * the same error type as generation.error. code is one of PROVIDER_ERROR
   * (the language model failed), CONTENT_BLOCKED (the provider refused the
   * content), TIMEOUT, SUPERSEDED (a newer message replaced this turn; not an
   * error to surface) or INTERNAL; message is a short user-safe sentence.
   * Unset on completed messages. Media messages report generation failures
   * through generation.error, and refused approvals through
   * action.rejection_reason / action.rejection_error instead.
   *
   * @generated from field: creativefabrica.modality.v1.GenerationError failure = 14;
   */
  failure?: GenerationError | undefined;

  /**
   * question is set on a completed assistant message that asks the user
   * something: Message.text is the whole reply (it contains the question) and
   * question carries the structured part to render as chips or an answer
   * field. The user answers with an ordinary SendMessage: the chosen option's
   * label (several labels joined with ", " when multi_select), or their own
   * words; a voice is answered with its name and id (see
   * AgentQuestion.voice_catalog). Unset for every other message.
   *
   * @generated from field: creativefabrica.studioagent.v1.AgentQuestion question = 15;
   */
  question?: AgentQuestion | undefined;
};

/**
 * Message is a single turn in a conversation.
 *
 * @generated from message creativefabrica.studioagent.v1.Message
 */
export type MessageJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.MessageRole role = 2;
   */
  role?: MessageRoleJson;

  /**
   * @generated from field: string text = 3;
   */
  text?: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.MessageStatus status = 4;
   */
  status?: MessageStatusJson;

  /**
   * @generated from field: creativefabrica.studioagent.v1.Usage usage = 5;
   */
  usage?: UsageJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: TimestampJson;

  /**
   * tool_events summarizes the tool calls the assistant made while producing
   * this message (generation-capable agents only; empty for pure chat).
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.ToolEvent tool_events = 7;
   */
  toolEvents?: ToolEventJson[];

  /**
   * type marks media-generation messages so clients render them as media
   * instead of a chat bubble.
   *
   * @generated from field: creativefabrica.studioagent.v1.MessageType type = 8;
   */
  type?: MessageTypeJson;

  /**
   * generation is the media generation attached to this message — set only on
   * type=media messages, carrying status, outputs, error and timestamps
   * inline, so a transcript renders media without extra calls or joins.
   *
   * @generated from field: creativefabrica.modality.v1.Generation generation = 9;
   */
  generation?: GenerationJson;

  /**
   * action is set on a completed assistant message that requires an explicit
   * user decision before the described work may begin.
   *
   * @generated from field: creativefabrica.studioagent.v1.MessageAction action = 10;
   */
  action?: MessageActionJson;

  /**
   * attachments are the reusable conversation inputs attached to this turn.
   * Their preview URLs are short-lived and may change between reads.
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.MessageAttachment attachments = 11;
   */
  attachments?: MessageAttachmentJson[];

  /**
   * expression is the single visual reaction cue the agent chose for this
   * assistant message (one of Agent.expression_cues). UNSPECIFIED for a
   * neutral reply, for user messages, for agents without a registry, and for
   * messages persisted before this field. Clients map the cue onto their own
   * mascot animation set and treat unknown values as neutral.
   *
   * @generated from field: creativefabrica.studioagent.v1.ExpressionCue expression = 12;
   */
  expression?: ExpressionCueJson;

  /**
   * thoughts are the model's own reasoning summaries for this assistant turn,
   * one entry per model round in order, when the provider returns them.
   * Product-facing text, not a transcript of tool calls (see tool_events).
   * Empty when the provider or agent does not produce them.
   *
   * @generated from field: repeated string thoughts = 13;
   */
  thoughts?: string[];

  /**
   * failure explains a chat turn that ended in MESSAGE_STATUS_FAILED, using
   * the same error type as generation.error. code is one of PROVIDER_ERROR
   * (the language model failed), CONTENT_BLOCKED (the provider refused the
   * content), TIMEOUT, SUPERSEDED (a newer message replaced this turn; not an
   * error to surface) or INTERNAL; message is a short user-safe sentence.
   * Unset on completed messages. Media messages report generation failures
   * through generation.error, and refused approvals through
   * action.rejection_reason / action.rejection_error instead.
   *
   * @generated from field: creativefabrica.modality.v1.GenerationError failure = 14;
   */
  failure?: GenerationErrorJson;

  /**
   * question is set on a completed assistant message that asks the user
   * something: Message.text is the whole reply (it contains the question) and
   * question carries the structured part to render as chips or an answer
   * field. The user answers with an ordinary SendMessage: the chosen option's
   * label (several labels joined with ", " when multi_select), or their own
   * words; a voice is answered with its name and id (see
   * AgentQuestion.voice_catalog). Unset for every other message.
   *
   * @generated from field: creativefabrica.studioagent.v1.AgentQuestion question = 15;
   */
  question?: AgentQuestionJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.Message.
 * Use `create(MessageSchema)` to create a new message.
 */
export const MessageSchema: GenMessage<Message, {jsonType: MessageJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 1);

/**
 * AgentQuestion is one clarifying question an agent asks, generic over what
 * is being asked: a choice of intent, a model, a voice, or an open answer.
 *
 * @generated from message creativefabrica.studioagent.v1.AgentQuestion
 */
export type AgentQuestion = Message$1<"creativefabrica.studioagent.v1.AgentQuestion"> & {
  /**
   * text is the question itself, one sentence, for a heading above the
   * options. Message.text may add a short lead-in around it.
   *
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * kind says what the options stand for, so a client can render richer
   * chips; UNSPECIFIED is a generic question with plain chips.
   *
   * @generated from field: creativefabrica.studioagent.v1.AgentQuestionKind kind = 2;
   */
  kind: AgentQuestionKind;

  /**
   * options are the answers in display order: none (an open question,
   * allow_free_text is then true) or 2 to 6. A VOICE question may have none:
   * it then offers the whole voice_catalog. A MODEL question lists every
   * model of the agent's catalog that fits the request: first the agent's
   * suggestions (AgentQuestionOption.suggested, 2 to 6, usually shown as
   * chips), then every other fitting model, cheapest first (usually shown in
   * a dropdown), so it may have many more than 6.
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.AgentQuestionOption options = 3;
   */
  options: AgentQuestionOption[];

  /**
   * multi_select lets the user pick several options before sending them as
   * one answer.
   *
   * @generated from field: bool multi_select = 4;
   */
  multiSelect: boolean;

  /**
   * allow_free_text says a typed answer is expected or welcome besides the
   * options (always true for an open question). The composer stays usable
   * either way; this only decides whether to offer an "other" field.
   *
   * @generated from field: bool allow_free_text = 5;
   */
  allowFreeText: boolean;

  /**
   * voice_catalog is set on every VOICE question: the speaker catalog its
   * voices come from (for example "elevenlabs_v3"). It tells the client the
   * whole catalog is available to choose from: list it with
   * creativefabrica.preset.v1.VoicesService.ListVoices (every voice with its
   * labels and audition clip), with the options, when present, as the agent's
   * suggestions. A picked voice, whether a suggested option or any voice from
   * the list, is answered with its name and its voice id, for example
   * "Charlotte - Calm Narrator (voice id abc123)": catalog names are not
   * unique (several voices can share a first name), so the agent uses the
   * id. Empty on other kinds.
   *
   * @generated from field: string voice_catalog = 6;
   */
  voiceCatalog: string;
};

/**
 * AgentQuestion is one clarifying question an agent asks, generic over what
 * is being asked: a choice of intent, a model, a voice, or an open answer.
 *
 * @generated from message creativefabrica.studioagent.v1.AgentQuestion
 */
export type AgentQuestionJson = {
  /**
   * text is the question itself, one sentence, for a heading above the
   * options. Message.text may add a short lead-in around it.
   *
   * @generated from field: string text = 1;
   */
  text?: string;

  /**
   * kind says what the options stand for, so a client can render richer
   * chips; UNSPECIFIED is a generic question with plain chips.
   *
   * @generated from field: creativefabrica.studioagent.v1.AgentQuestionKind kind = 2;
   */
  kind?: AgentQuestionKindJson;

  /**
   * options are the answers in display order: none (an open question,
   * allow_free_text is then true) or 2 to 6. A VOICE question may have none:
   * it then offers the whole voice_catalog. A MODEL question lists every
   * model of the agent's catalog that fits the request: first the agent's
   * suggestions (AgentQuestionOption.suggested, 2 to 6, usually shown as
   * chips), then every other fitting model, cheapest first (usually shown in
   * a dropdown), so it may have many more than 6.
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.AgentQuestionOption options = 3;
   */
  options?: AgentQuestionOptionJson[];

  /**
   * multi_select lets the user pick several options before sending them as
   * one answer.
   *
   * @generated from field: bool multi_select = 4;
   */
  multiSelect?: boolean;

  /**
   * allow_free_text says a typed answer is expected or welcome besides the
   * options (always true for an open question). The composer stays usable
   * either way; this only decides whether to offer an "other" field.
   *
   * @generated from field: bool allow_free_text = 5;
   */
  allowFreeText?: boolean;

  /**
   * voice_catalog is set on every VOICE question: the speaker catalog its
   * voices come from (for example "elevenlabs_v3"). It tells the client the
   * whole catalog is available to choose from: list it with
   * creativefabrica.preset.v1.VoicesService.ListVoices (every voice with its
   * labels and audition clip), with the options, when present, as the agent's
   * suggestions. A picked voice, whether a suggested option or any voice from
   * the list, is answered with its name and its voice id, for example
   * "Charlotte - Calm Narrator (voice id abc123)": catalog names are not
   * unique (several voices can share a first name), so the agent uses the
   * id. Empty on other kinds.
   *
   * @generated from field: string voice_catalog = 6;
   */
  voiceCatalog?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.AgentQuestion.
 * Use `create(AgentQuestionSchema)` to create a new message.
 */
export const AgentQuestionSchema: GenMessage<AgentQuestion, {jsonType: AgentQuestionJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 2);

/**
 * AgentQuestionOption is one suggested answer to an AgentQuestion.
 *
 * @generated from message creativefabrica.studioagent.v1.AgentQuestionOption
 */
export type AgentQuestionOption = Message$1<"creativefabrica.studioagent.v1.AgentQuestionOption"> & {
  /**
   * label is the answer as the user would say it; sending it back is the
   * answer (for a VOICE option, together with its voice id; see
   * AgentQuestion.voice_catalog). For MODEL and VOICE options it is the
   * catalog name of the model or voice in value, set by the server.
   *
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * description is an optional one-line hint shown with the label, for
   * example a model's price and strength.
   *
   * @generated from field: string description = 2;
   */
  description: string;

  /**
   * value is the machine id the option stands for when the question's kind
   * has one (a model id or a voice id), checked by the server against the
   * catalog; empty for generic and intent answers.
   *
   * @generated from field: string value = 3;
   */
  value: string;

  /**
   * preview_url is a playable sample of the option (a voice's audition clip),
   * set by the server from the catalog, never by the model; empty otherwise.
   *
   * @generated from field: string preview_url = 4;
   */
  previewUrl: string;

  /**
   * suggested marks the agent's recommendations among a MODEL question's
   * options (they come first; the "let the agent choose" option is one of
   * them); the rest are every other model that fits. Always false on other
   * kinds, whose options are all suggestions.
   *
   * @generated from field: bool suggested = 5;
   */
  suggested: boolean;

  /**
   * icon_url is the option's catalog icon (a model's provider logo), set by
   * the server, never by the model; empty when the catalog has none.
   *
   * @generated from field: string icon_url = 6;
   */
  iconUrl: string;
};

/**
 * AgentQuestionOption is one suggested answer to an AgentQuestion.
 *
 * @generated from message creativefabrica.studioagent.v1.AgentQuestionOption
 */
export type AgentQuestionOptionJson = {
  /**
   * label is the answer as the user would say it; sending it back is the
   * answer (for a VOICE option, together with its voice id; see
   * AgentQuestion.voice_catalog). For MODEL and VOICE options it is the
   * catalog name of the model or voice in value, set by the server.
   *
   * @generated from field: string label = 1;
   */
  label?: string;

  /**
   * description is an optional one-line hint shown with the label, for
   * example a model's price and strength.
   *
   * @generated from field: string description = 2;
   */
  description?: string;

  /**
   * value is the machine id the option stands for when the question's kind
   * has one (a model id or a voice id), checked by the server against the
   * catalog; empty for generic and intent answers.
   *
   * @generated from field: string value = 3;
   */
  value?: string;

  /**
   * preview_url is a playable sample of the option (a voice's audition clip),
   * set by the server from the catalog, never by the model; empty otherwise.
   *
   * @generated from field: string preview_url = 4;
   */
  previewUrl?: string;

  /**
   * suggested marks the agent's recommendations among a MODEL question's
   * options (they come first; the "let the agent choose" option is one of
   * them); the rest are every other model that fits. Always false on other
   * kinds, whose options are all suggestions.
   *
   * @generated from field: bool suggested = 5;
   */
  suggested?: boolean;

  /**
   * icon_url is the option's catalog icon (a model's provider logo), set by
   * the server, never by the model; empty when the catalog has none.
   *
   * @generated from field: string icon_url = 6;
   */
  iconUrl?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.AgentQuestionOption.
 * Use `create(AgentQuestionOptionSchema)` to create a new message.
 */
export const AgentQuestionOptionSchema: GenMessage<AgentQuestionOption, {jsonType: AgentQuestionOptionJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 3);

/**
 * MessageAction contains approval state only. Media generation lifecycle state
 * belongs to the separate MESSAGE_TYPE_MEDIA message created after approval.
 *
 * @generated from message creativefabrica.studioagent.v1.MessageAction
 */
export type MessageAction = Message$1<"creativefabrica.studioagent.v1.MessageAction"> & {
  /**
   * @generated from field: creativefabrica.studioagent.v1.MessageActionState state = 1;
   */
  state: MessageActionState;

  /**
   * quoted_coin_amount is the price shown when the proposal was created.
   *
   * @generated from field: int64 quoted_coin_amount = 2;
   */
  quotedCoinAmount: bigint;

  /**
   * approved_coin_amount is the price recalculated immediately before an
   * approved proposal is dispatched. It is absent until approval succeeds.
   *
   * @generated from field: optional int64 approved_coin_amount = 3;
   */
  approvedCoinAmount?: bigint | undefined;

  /**
   * Set only when state is MESSAGE_ACTION_STATE_REJECTED.
   *
   * @generated from field: creativefabrica.studioagent.v1.MessageActionRejectionReason rejection_reason = 4;
   */
  rejectionReason: MessageActionRejectionReason;

  /**
   * @generated from oneof creativefabrica.studioagent.v1.MessageAction.action
   */
  action: {
    /**
     * @generated from field: creativefabrica.studioagent.v1.MediaGenerationApproval media_generation_approval = 5;
     */
    value: MediaGenerationApproval;
    case: "mediaGenerationApproval";
  } | { case: undefined; value?: undefined };

  /**
   * decided_at is absent while the action is awaiting approval.
   *
   * @generated from field: google.protobuf.Timestamp decided_at = 6;
   */
  decidedAt?: Timestamp | undefined;

  /**
   * rejection_error carries the structured cause of a server-side rejection
   * (INSUFFICIENT_BALANCE, SUBSCRIPTION_REQUIRED, PAYMENT_REQUIRED,
   * REQUEST_UNAVAILABLE): the coins CoinError with its code, message,
   * insufficient-fund and payment-intent details, or the validation field
   * violations — the same errors.v1.Error clients already parse from
   * FAILED_PRECONDITION responses. Unset for user decisions and supersede.
   *
   * @generated from field: creativefabrica.errors.v1.Error rejection_error = 7;
   */
  rejectionError?: Error | undefined;
};

/**
 * MessageAction contains approval state only. Media generation lifecycle state
 * belongs to the separate MESSAGE_TYPE_MEDIA message created after approval.
 *
 * @generated from message creativefabrica.studioagent.v1.MessageAction
 */
export type MessageActionJson = {
  /**
   * @generated from field: creativefabrica.studioagent.v1.MessageActionState state = 1;
   */
  state?: MessageActionStateJson;

  /**
   * quoted_coin_amount is the price shown when the proposal was created.
   *
   * @generated from field: int64 quoted_coin_amount = 2;
   */
  quotedCoinAmount?: string;

  /**
   * approved_coin_amount is the price recalculated immediately before an
   * approved proposal is dispatched. It is absent until approval succeeds.
   *
   * @generated from field: optional int64 approved_coin_amount = 3;
   */
  approvedCoinAmount?: string;

  /**
   * Set only when state is MESSAGE_ACTION_STATE_REJECTED.
   *
   * @generated from field: creativefabrica.studioagent.v1.MessageActionRejectionReason rejection_reason = 4;
   */
  rejectionReason?: MessageActionRejectionReasonJson;

  /**
   * @generated from field: creativefabrica.studioagent.v1.MediaGenerationApproval media_generation_approval = 5;
   */
  mediaGenerationApproval?: MediaGenerationApprovalJson;

  /**
   * decided_at is absent while the action is awaiting approval.
   *
   * @generated from field: google.protobuf.Timestamp decided_at = 6;
   */
  decidedAt?: TimestampJson;

  /**
   * rejection_error carries the structured cause of a server-side rejection
   * (INSUFFICIENT_BALANCE, SUBSCRIPTION_REQUIRED, PAYMENT_REQUIRED,
   * REQUEST_UNAVAILABLE): the coins CoinError with its code, message,
   * insufficient-fund and payment-intent details, or the validation field
   * violations — the same errors.v1.Error clients already parse from
   * FAILED_PRECONDITION responses. Unset for user decisions and supersede.
   *
   * @generated from field: creativefabrica.errors.v1.Error rejection_error = 7;
   */
  rejectionError?: ErrorJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.MessageAction.
 * Use `create(MessageActionSchema)` to create a new message.
 */
export const MessageActionSchema: GenMessage<MessageAction, {jsonType: MessageActionJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 4);

/**
 * MediaGenerationApproval describes the media request that needs consent.
 *
 * @generated from message creativefabrica.studioagent.v1.MediaGenerationApproval
 */
export type MediaGenerationApproval = Message$1<"creativefabrica.studioagent.v1.MediaGenerationApproval"> & {
  /**
   * @generated from field: creativefabrica.modality.v1.MediaType output_media_type = 1;
   */
  outputMediaType: MediaType;

  /**
   * generation_plan is the frozen generic-agent request. Character actions
   * omit it because their model, prompt enrichment, and options are internal.
   *
   * @generated from field: creativefabrica.studioagent.v1.GenerationPlan generation_plan = 2;
   */
  generationPlan?: GenerationPlan | undefined;

  /**
   * model_choices lists the models the user may choose for this card, the
   * agent's suggestions first, always including generation_plan.model. Every
   * listed model can do this card's job with its exact inputs and prompt: it
   * takes every input in its role, within that role's limits, and accepts the
   * card's content. Non-empty means the card's settings may be changed before
   * approval (ResolveMessageActionRequest.plan_choice); one entry means the
   * settings are editable but the model is fixed. Empty means the card is
   * read-only, as every card was before this field: a speech card, a resolved
   * card, or an agent that does not offer editing. Each model's options come
   * from ListGenerationModels.
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.ModelChoice model_choices = 3;
   */
  modelChoices: ModelChoice[];
};

/**
 * MediaGenerationApproval describes the media request that needs consent.
 *
 * @generated from message creativefabrica.studioagent.v1.MediaGenerationApproval
 */
export type MediaGenerationApprovalJson = {
  /**
   * @generated from field: creativefabrica.modality.v1.MediaType output_media_type = 1;
   */
  outputMediaType?: MediaTypeJson;

  /**
   * generation_plan is the frozen generic-agent request. Character actions
   * omit it because their model, prompt enrichment, and options are internal.
   *
   * @generated from field: creativefabrica.studioagent.v1.GenerationPlan generation_plan = 2;
   */
  generationPlan?: GenerationPlanJson;

  /**
   * model_choices lists the models the user may choose for this card, the
   * agent's suggestions first, always including generation_plan.model. Every
   * listed model can do this card's job with its exact inputs and prompt: it
   * takes every input in its role, within that role's limits, and accepts the
   * card's content. Non-empty means the card's settings may be changed before
   * approval (ResolveMessageActionRequest.plan_choice); one entry means the
   * settings are editable but the model is fixed. Empty means the card is
   * read-only, as every card was before this field: a speech card, a resolved
   * card, or an agent that does not offer editing. Each model's options come
   * from ListGenerationModels.
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.ModelChoice model_choices = 3;
   */
  modelChoices?: ModelChoiceJson[];
};

/**
 * Describes the message creativefabrica.studioagent.v1.MediaGenerationApproval.
 * Use `create(MediaGenerationApprovalSchema)` to create a new message.
 */
export const MediaGenerationApprovalSchema: GenMessage<MediaGenerationApproval, {jsonType: MediaGenerationApprovalJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 5);

/**
 * ModelChoice is one model a card may be switched to: enough to render a model
 * dropdown before any catalog is fetched. It carries no description and no
 * price — a model has no single price, it depends on the chosen options; the
 * client quotes the selected model and options with
 * creativefabrica.preset.v1.AIProviderService.CalculateModelCost.
 *
 * @generated from message creativefabrica.studioagent.v1.ModelChoice
 */
export type ModelChoice = Message$1<"creativefabrica.studioagent.v1.ModelChoice"> & {
  /**
   * model is the model id, the same id space as GenerationPlan.model and
   * CatalogModel.capabilities.model.
   *
   * @generated from field: string model = 1;
   */
  model: string;

  /**
   * label is the catalog display name.
   *
   * @generated from field: string label = 2;
   */
  label: string;

  /**
   * icon_url is the model's catalog icon (provider logo), when it has one.
   *
   * @generated from field: string icon_url = 3;
   */
  iconUrl: string;

  /**
   * suggested marks one of the agent's picks; the other entries are every
   * other model that fits the card.
   *
   * @generated from field: bool suggested = 4;
   */
  suggested: boolean;
};

/**
 * ModelChoice is one model a card may be switched to: enough to render a model
 * dropdown before any catalog is fetched. It carries no description and no
 * price — a model has no single price, it depends on the chosen options; the
 * client quotes the selected model and options with
 * creativefabrica.preset.v1.AIProviderService.CalculateModelCost.
 *
 * @generated from message creativefabrica.studioagent.v1.ModelChoice
 */
export type ModelChoiceJson = {
  /**
   * model is the model id, the same id space as GenerationPlan.model and
   * CatalogModel.capabilities.model.
   *
   * @generated from field: string model = 1;
   */
  model?: string;

  /**
   * label is the catalog display name.
   *
   * @generated from field: string label = 2;
   */
  label?: string;

  /**
   * icon_url is the model's catalog icon (provider logo), when it has one.
   *
   * @generated from field: string icon_url = 3;
   */
  iconUrl?: string;

  /**
   * suggested marks one of the agent's picks; the other entries are every
   * other model that fits the card.
   *
   * @generated from field: bool suggested = 4;
   */
  suggested?: boolean;
};

/**
 * Describes the message creativefabrica.studioagent.v1.ModelChoice.
 * Use `create(ModelChoiceSchema)` to create a new message.
 */
export const ModelChoiceSchema: GenMessage<ModelChoice, {jsonType: ModelChoiceJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 6);

/**
 * GenerationPlan is the exact generic-agent request approved by the user.
 * Approval dispatches this frozen model, modality, prompt, options, and input
 * selection, and recalculates only the coin price — unless the approval
 * carries a ResolveMessageActionRequest.plan_choice, which replaces the model
 * and options with the user's choice from MediaGenerationApproval.model_choices
 * before the same validation and pricing.
 *
 * @generated from message creativefabrica.studioagent.v1.GenerationPlan
 */
export type GenerationPlan = Message$1<"creativefabrica.studioagent.v1.GenerationPlan"> & {
  /**
   * @generated from field: string model = 1;
   */
  model: string;

  /**
   * @generated from field: creativefabrica.preset.v1.Modality modality = 2;
   */
  modality: Modality;

  /**
   * @generated from field: string prompt = 3;
   */
  prompt: string;

  /**
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> options = 4;
   */
  options: { [key: string]: FieldValue };

  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.GenerationPlanInput inputs = 5;
   */
  inputs: GenerationPlanInput[];

  /**
   * voice_catalog names the speaker catalog of a speech model whose options
   * carry catalog voices (for example "elevenlabs_v3"); empty otherwise. List
   * its voices with creativefabrica.preset.v1.VoicesService.ListVoices and
   * swap a voice on approval with ResolveMessageActionRequest.voice_choices.
   *
   * @generated from field: string voice_catalog = 6;
   */
  voiceCatalog: string;
};

/**
 * GenerationPlan is the exact generic-agent request approved by the user.
 * Approval dispatches this frozen model, modality, prompt, options, and input
 * selection, and recalculates only the coin price — unless the approval
 * carries a ResolveMessageActionRequest.plan_choice, which replaces the model
 * and options with the user's choice from MediaGenerationApproval.model_choices
 * before the same validation and pricing.
 *
 * @generated from message creativefabrica.studioagent.v1.GenerationPlan
 */
export type GenerationPlanJson = {
  /**
   * @generated from field: string model = 1;
   */
  model?: string;

  /**
   * @generated from field: creativefabrica.preset.v1.Modality modality = 2;
   */
  modality?: ModalityJson;

  /**
   * @generated from field: string prompt = 3;
   */
  prompt?: string;

  /**
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> options = 4;
   */
  options?: { [key: string]: FieldValueJson };

  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.GenerationPlanInput inputs = 5;
   */
  inputs?: GenerationPlanInputJson[];

  /**
   * voice_catalog names the speaker catalog of a speech model whose options
   * carry catalog voices (for example "elevenlabs_v3"); empty otherwise. List
   * its voices with creativefabrica.preset.v1.VoicesService.ListVoices and
   * swap a voice on approval with ResolveMessageActionRequest.voice_choices.
   *
   * @generated from field: string voice_catalog = 6;
   */
  voiceCatalog?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.GenerationPlan.
 * Use `create(GenerationPlanSchema)` to create a new message.
 */
export const GenerationPlanSchema: GenMessage<GenerationPlan, {jsonType: GenerationPlanJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 7);

/**
 * GenerationPlanInput records one reusable conversation input selected by the
 * agent and explains how it will be passed to the generation provider.
 *
 * @generated from message creativefabrica.studioagent.v1.GenerationPlanInput
 */
export type GenerationPlanInput = Message$1<"creativefabrica.studioagent.v1.GenerationPlanInput"> & {
  /**
   * @generated from field: creativefabrica.studioagent.v1.InputRef input_ref = 1;
   */
  inputRef?: InputRef | undefined;

  /**
   * role is the model input role (for example firstFrame or referenceImage).
   * It is empty for flat-file modalities.
   *
   * @generated from field: string role = 2;
   */
  role: string;

  /**
   * alias is the exact prompt placeholder alias cited as {{alias}} in the
   * prompt. It is derived from the input token body (for example "upload_1"
   * for {{upload_1}}) on reference roles and empty for structural roles such
   * as firstFrame and lastFrame, whose token is replaced by a role phrase in
   * the prompt before dispatch.
   *
   * @generated from field: string alias = 3;
   */
  alias: string;

  /**
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> provider_metadata = 4;
   */
  providerMetadata: { [key: string]: FieldValue };

  /**
   * LLM-authored, product-facing explanation of how this input will be used.
   *
   * @generated from field: string usage_explanation = 5;
   */
  usageExplanation: string;
};

/**
 * GenerationPlanInput records one reusable conversation input selected by the
 * agent and explains how it will be passed to the generation provider.
 *
 * @generated from message creativefabrica.studioagent.v1.GenerationPlanInput
 */
export type GenerationPlanInputJson = {
  /**
   * @generated from field: creativefabrica.studioagent.v1.InputRef input_ref = 1;
   */
  inputRef?: InputRefJson;

  /**
   * role is the model input role (for example firstFrame or referenceImage).
   * It is empty for flat-file modalities.
   *
   * @generated from field: string role = 2;
   */
  role?: string;

  /**
   * alias is the exact prompt placeholder alias cited as {{alias}} in the
   * prompt. It is derived from the input token body (for example "upload_1"
   * for {{upload_1}}) on reference roles and empty for structural roles such
   * as firstFrame and lastFrame, whose token is replaced by a role phrase in
   * the prompt before dispatch.
   *
   * @generated from field: string alias = 3;
   */
  alias?: string;

  /**
   * @generated from field: map<string, creativefabrica.preset.v1.FieldValue> provider_metadata = 4;
   */
  providerMetadata?: { [key: string]: FieldValueJson };

  /**
   * LLM-authored, product-facing explanation of how this input will be used.
   *
   * @generated from field: string usage_explanation = 5;
   */
  usageExplanation?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.GenerationPlanInput.
 * Use `create(GenerationPlanInputSchema)` to create a new message.
 */
export const GenerationPlanInputSchema: GenMessage<GenerationPlanInput, {jsonType: GenerationPlanInputJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 8);

/**
 * MessageAttachment is a product-safe snapshot of one reusable input attached
 * to a message. Storage keys and upload/provider identifiers are never exposed.
 *
 * @generated from message creativefabrica.studioagent.v1.MessageAttachment
 */
export type MessageAttachment = Message$1<"creativefabrica.studioagent.v1.MessageAttachment"> & {
  /**
   * ref is the conversation asset token, for example {{upload_1}}.
   *
   * @generated from field: string ref = 1;
   */
  ref: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.AgentInputMediaSource source = 2;
   */
  source: AgentInputMediaSource;

  /**
   * @generated from field: creativefabrica.modality.v1.MediaType media_type = 3;
   */
  mediaType: MediaType;

  /**
   * @generated from field: string file_name = 4;
   */
  fileName: string;

  /**
   * @generated from field: string mime_type = 5;
   */
  mimeType: string;

  /**
   * @generated from field: optional int32 width = 6;
   */
  width?: number | undefined;

  /**
   * @generated from field: optional int32 height = 7;
   */
  height?: number | undefined;

  /**
   * @generated from field: optional int32 duration_seconds = 8;
   */
  durationSeconds?: number | undefined;

  /**
   * @generated from field: creativefabrica.studioagent.v1.InputRefReadiness readiness = 9;
   */
  readiness: InputRefReadiness;

  /**
   * preview_url is a short-lived authenticated read URL.
   *
   * @generated from field: string preview_url = 10;
   */
  previewUrl: string;
};

/**
 * MessageAttachment is a product-safe snapshot of one reusable input attached
 * to a message. Storage keys and upload/provider identifiers are never exposed.
 *
 * @generated from message creativefabrica.studioagent.v1.MessageAttachment
 */
export type MessageAttachmentJson = {
  /**
   * ref is the conversation asset token, for example {{upload_1}}.
   *
   * @generated from field: string ref = 1;
   */
  ref?: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.AgentInputMediaSource source = 2;
   */
  source?: AgentInputMediaSourceJson;

  /**
   * @generated from field: creativefabrica.modality.v1.MediaType media_type = 3;
   */
  mediaType?: MediaTypeJson;

  /**
   * @generated from field: string file_name = 4;
   */
  fileName?: string;

  /**
   * @generated from field: string mime_type = 5;
   */
  mimeType?: string;

  /**
   * @generated from field: optional int32 width = 6;
   */
  width?: number;

  /**
   * @generated from field: optional int32 height = 7;
   */
  height?: number;

  /**
   * @generated from field: optional int32 duration_seconds = 8;
   */
  durationSeconds?: number;

  /**
   * @generated from field: creativefabrica.studioagent.v1.InputRefReadiness readiness = 9;
   */
  readiness?: InputRefReadinessJson;

  /**
   * preview_url is a short-lived authenticated read URL.
   *
   * @generated from field: string preview_url = 10;
   */
  previewUrl?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.MessageAttachment.
 * Use `create(MessageAttachmentSchema)` to create a new message.
 */
export const MessageAttachmentSchema: GenMessage<MessageAttachment, {jsonType: MessageAttachmentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 9);

/**
 * InputRef is a product-safe reusable conversation media reference addressed
 * by its token, such as {{upload_1}} or {{image_2}}. The same token is written
 * in chat text and in generation prompts. Storage keys and upload/provider
 * identifiers are never exposed.
 *
 * @generated from message creativefabrica.studioagent.v1.InputRef
 */
export type InputRef = Message$1<"creativefabrica.studioagent.v1.InputRef"> & {
  /**
   * @generated from field: string ref = 1;
   */
  ref: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.AgentInputMediaSource source = 2;
   */
  source: AgentInputMediaSource;

  /**
   * @generated from field: creativefabrica.modality.v1.MediaType media_type = 3;
   */
  mediaType: MediaType;

  /**
   * @generated from field: string file_name = 4;
   */
  fileName: string;

  /**
   * @generated from field: string mime_type = 5;
   */
  mimeType: string;

  /**
   * @generated from field: optional int32 width = 6;
   */
  width?: number | undefined;

  /**
   * @generated from field: optional int32 height = 7;
   */
  height?: number | undefined;

  /**
   * @generated from field: optional int32 duration_seconds = 8;
   */
  durationSeconds?: number | undefined;

  /**
   * @generated from field: creativefabrica.studioagent.v1.InputRefReadiness readiness = 9;
   */
  readiness: InputRefReadiness;

  /**
   * preview_url is a short-lived authenticated read URL.
   *
   * @generated from field: string preview_url = 10;
   */
  previewUrl: string;

  /**
   * fps is a video's probed frame rate rounded to the nearest integer; absent
   * for other media and for videos whose probe found none. With width, height
   * and duration_seconds it is the metadata CalculateModelCost needs to quote
   * a model priced on its input media.
   *
   * @generated from field: optional int32 fps = 11;
   */
  fps?: number | undefined;

  /**
   * metadata is the caller-defined provenance of an asset registered with
   * RegisterExternalAsset (tool_name, id, …); empty for uploads and for the
   * conversation's own generated outputs.
   *
   * @generated from field: map<string, string> metadata = 12;
   */
  metadata: { [key: string]: string };

  /**
   * web_import is set only when source is WEB_IMPORT.
   *
   * @generated from field: creativefabrica.studioagent.v1.WebImport web_import = 13;
   */
  webImport?: WebImport | undefined;
};

/**
 * InputRef is a product-safe reusable conversation media reference addressed
 * by its token, such as {{upload_1}} or {{image_2}}. The same token is written
 * in chat text and in generation prompts. Storage keys and upload/provider
 * identifiers are never exposed.
 *
 * @generated from message creativefabrica.studioagent.v1.InputRef
 */
export type InputRefJson = {
  /**
   * @generated from field: string ref = 1;
   */
  ref?: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.AgentInputMediaSource source = 2;
   */
  source?: AgentInputMediaSourceJson;

  /**
   * @generated from field: creativefabrica.modality.v1.MediaType media_type = 3;
   */
  mediaType?: MediaTypeJson;

  /**
   * @generated from field: string file_name = 4;
   */
  fileName?: string;

  /**
   * @generated from field: string mime_type = 5;
   */
  mimeType?: string;

  /**
   * @generated from field: optional int32 width = 6;
   */
  width?: number;

  /**
   * @generated from field: optional int32 height = 7;
   */
  height?: number;

  /**
   * @generated from field: optional int32 duration_seconds = 8;
   */
  durationSeconds?: number;

  /**
   * @generated from field: creativefabrica.studioagent.v1.InputRefReadiness readiness = 9;
   */
  readiness?: InputRefReadinessJson;

  /**
   * preview_url is a short-lived authenticated read URL.
   *
   * @generated from field: string preview_url = 10;
   */
  previewUrl?: string;

  /**
   * fps is a video's probed frame rate rounded to the nearest integer; absent
   * for other media and for videos whose probe found none. With width, height
   * and duration_seconds it is the metadata CalculateModelCost needs to quote
   * a model priced on its input media.
   *
   * @generated from field: optional int32 fps = 11;
   */
  fps?: number;

  /**
   * metadata is the caller-defined provenance of an asset registered with
   * RegisterExternalAsset (tool_name, id, …); empty for uploads and for the
   * conversation's own generated outputs.
   *
   * @generated from field: map<string, string> metadata = 12;
   */
  metadata?: { [key: string]: string };

  /**
   * web_import is set only when source is WEB_IMPORT.
   *
   * @generated from field: creativefabrica.studioagent.v1.WebImport web_import = 13;
   */
  webImport?: WebImportJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.InputRef.
 * Use `create(InputRefSchema)` to create a new message.
 */
export const InputRefSchema: GenMessage<InputRef, {jsonType: InputRefJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 10);

/**
 * WebImport describes a conversation input the server fetches from a URL
 * outside Creative Fabrica, and how far that fetch has got.
 *
 * @generated from message creativefabrica.studioagent.v1.WebImport
 */
export type WebImport = Message$1<"creativefabrica.studioagent.v1.WebImport"> & {
  /**
   * source_url is the URL the user dropped, kept for attribution and rights.
   * Returned by the owner's RPCs only; empty in notifications.
   *
   * @generated from field: string source_url = 1;
   */
  sourceUrl: string;

  /**
   * source_host is the URL's host, for display (for example
   * "upload.wikimedia.org").
   *
   * @generated from field: string source_host = 2;
   */
  sourceHost: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.WebImportStage stage = 3;
   */
  stage: WebImportStage;

  /**
   * @generated from field: int64 bytes_received = 4;
   */
  bytesReceived: bigint;

  /**
   * total_bytes is the size the origin announced; absent when it sent none.
   *
   * @generated from field: optional int64 total_bytes = 5;
   */
  totalBytes?: bigint | undefined;

  /**
   * failure is set only when stage is FAILED.
   *
   * @generated from field: creativefabrica.studioagent.v1.WebImportFailure failure = 6;
   */
  failure: WebImportFailure;

  /**
   * updated_at orders updates: apply one only when it is newer than the
   * update already applied, since notifications can arrive out of order.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * WebImport describes a conversation input the server fetches from a URL
 * outside Creative Fabrica, and how far that fetch has got.
 *
 * @generated from message creativefabrica.studioagent.v1.WebImport
 */
export type WebImportJson = {
  /**
   * source_url is the URL the user dropped, kept for attribution and rights.
   * Returned by the owner's RPCs only; empty in notifications.
   *
   * @generated from field: string source_url = 1;
   */
  sourceUrl?: string;

  /**
   * source_host is the URL's host, for display (for example
   * "upload.wikimedia.org").
   *
   * @generated from field: string source_host = 2;
   */
  sourceHost?: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.WebImportStage stage = 3;
   */
  stage?: WebImportStageJson;

  /**
   * @generated from field: int64 bytes_received = 4;
   */
  bytesReceived?: string;

  /**
   * total_bytes is the size the origin announced; absent when it sent none.
   *
   * @generated from field: optional int64 total_bytes = 5;
   */
  totalBytes?: string;

  /**
   * failure is set only when stage is FAILED.
   *
   * @generated from field: creativefabrica.studioagent.v1.WebImportFailure failure = 6;
   */
  failure?: WebImportFailureJson;

  /**
   * updated_at orders updates: apply one only when it is newer than the
   * update already applied, since notifications can arrive out of order.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 7;
   */
  updatedAt?: TimestampJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.WebImport.
 * Use `create(WebImportSchema)` to create a new message.
 */
export const WebImportSchema: GenMessage<WebImport, {jsonType: WebImportJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 11);

/**
 * ToolEvent is an FE-renderable summary of one tool call made during a turn.
 *
 * @generated from message creativefabrica.studioagent.v1.ToolEvent
 */
export type ToolEvent = Message$1<"creativefabrica.studioagent.v1.ToolEvent"> & {
  /**
   * @generated from field: string tool_call_id = 1;
   */
  toolCallId: string;

  /**
   * summary is a short human-readable line (e.g. "queued textToImage on model X").
   *
   * @generated from field: string summary = 4;
   */
  summary: string;

  /**
   * generation_id is set when this call dispatched a generation.
   *
   * @generated from field: string generation_id = 5;
   */
  generationId: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.Tool tool = 6;
   */
  tool: Tool;

  /**
   * @generated from field: creativefabrica.studioagent.v1.ToolCallOutcome outcome = 7;
   */
  outcome: ToolCallOutcome;

  /**
   * detail is a short human-readable rendering of the call's arguments (for
   * example "seedance_2_5, textToVideo, 720p, 5 s"), so clients can show what
   * the agent looked up. Never contains secrets or raw URLs.
   *
   * @generated from field: string detail = 8;
   */
  detail: string;
};

/**
 * ToolEvent is an FE-renderable summary of one tool call made during a turn.
 *
 * @generated from message creativefabrica.studioagent.v1.ToolEvent
 */
export type ToolEventJson = {
  /**
   * @generated from field: string tool_call_id = 1;
   */
  toolCallId?: string;

  /**
   * summary is a short human-readable line (e.g. "queued textToImage on model X").
   *
   * @generated from field: string summary = 4;
   */
  summary?: string;

  /**
   * generation_id is set when this call dispatched a generation.
   *
   * @generated from field: string generation_id = 5;
   */
  generationId?: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.Tool tool = 6;
   */
  tool?: ToolJson;

  /**
   * @generated from field: creativefabrica.studioagent.v1.ToolCallOutcome outcome = 7;
   */
  outcome?: ToolCallOutcomeJson;

  /**
   * detail is a short human-readable rendering of the call's arguments (for
   * example "seedance_2_5, textToVideo, 720p, 5 s"), so clients can show what
   * the agent looked up. Never contains secrets or raw URLs.
   *
   * @generated from field: string detail = 8;
   */
  detail?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.ToolEvent.
 * Use `create(ToolEventSchema)` to create a new message.
 */
export const ToolEventSchema: GenMessage<ToolEvent, {jsonType: ToolEventJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 12);

/**
 * OutputRef is one entry in a conversation's media reference registry: a
 * completed generation output addressable by its token {{image_N}} /
 * {{video_N}} / {{audio_N}} for chaining into subsequent generations and FE
 * rendering. The media itself reuses the modality OutputMedia shape (typed
 * image/video/audio content with urls, thumbnails, dimensions, duration) — the
 * ref layer only adds the registry handle and alias.
 *
 * @generated from message creativefabrica.studioagent.v1.OutputRef
 */
export type OutputRef = Message$1<"creativefabrica.studioagent.v1.OutputRef"> & {
  /**
   * @generated from field: string ref = 1;
   */
  ref: string;

  /**
   * alias is the prompt-citation alias when this ref is used on a reference
   * role ({{alias}} in the prompt); it equals the token body (for example
   * "image_1") and is empty until assigned.
   *
   * @generated from field: string alias = 2;
   */
  alias: string;

  /**
   * generation_id is the studio-agents generation record this output came from.
   *
   * @generated from field: string generation_id = 3;
   */
  generationId: string;

  /**
   * @generated from field: creativefabrica.modality.v1.OutputMedia media = 4;
   */
  media?: OutputMedia | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;
};

/**
 * OutputRef is one entry in a conversation's media reference registry: a
 * completed generation output addressable by its token {{image_N}} /
 * {{video_N}} / {{audio_N}} for chaining into subsequent generations and FE
 * rendering. The media itself reuses the modality OutputMedia shape (typed
 * image/video/audio content with urls, thumbnails, dimensions, duration) — the
 * ref layer only adds the registry handle and alias.
 *
 * @generated from message creativefabrica.studioagent.v1.OutputRef
 */
export type OutputRefJson = {
  /**
   * @generated from field: string ref = 1;
   */
  ref?: string;

  /**
   * alias is the prompt-citation alias when this ref is used on a reference
   * role ({{alias}} in the prompt); it equals the token body (for example
   * "image_1") and is empty until assigned.
   *
   * @generated from field: string alias = 2;
   */
  alias?: string;

  /**
   * generation_id is the studio-agents generation record this output came from.
   *
   * @generated from field: string generation_id = 3;
   */
  generationId?: string;

  /**
   * @generated from field: creativefabrica.modality.v1.OutputMedia media = 4;
   */
  media?: OutputMediaJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: TimestampJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.OutputRef.
 * Use `create(OutputRefSchema)` to create a new message.
 */
export const OutputRefSchema: GenMessage<OutputRef, {jsonType: OutputRefJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 13);

/**
 * ConversationGeneration anchors one fire-and-forget media generation to the
 * conversation turn that dispatched it. The generation state itself reuses the
 * modality Generation shape (status, modality, model, progress, outputs,
 * error, timestamps).
 *
 * @generated from message creativefabrica.studioagent.v1.ConversationGeneration
 */
export type ConversationGeneration = Message$1<"creativefabrica.studioagent.v1.ConversationGeneration"> & {
  /**
   * message_id is the assistant message whose turn dispatched the generation.
   *
   * @generated from field: string message_id = 1;
   */
  messageId: string;

  /**
   * @generated from field: creativefabrica.modality.v1.Generation generation = 2;
   */
  generation?: Generation | undefined;
};

/**
 * ConversationGeneration anchors one fire-and-forget media generation to the
 * conversation turn that dispatched it. The generation state itself reuses the
 * modality Generation shape (status, modality, model, progress, outputs,
 * error, timestamps).
 *
 * @generated from message creativefabrica.studioagent.v1.ConversationGeneration
 */
export type ConversationGenerationJson = {
  /**
   * message_id is the assistant message whose turn dispatched the generation.
   *
   * @generated from field: string message_id = 1;
   */
  messageId?: string;

  /**
   * @generated from field: creativefabrica.modality.v1.Generation generation = 2;
   */
  generation?: GenerationJson;
};

/**
 * Describes the message creativefabrica.studioagent.v1.ConversationGeneration.
 * Use `create(ConversationGenerationSchema)` to create a new message.
 */
export const ConversationGenerationSchema: GenMessage<ConversationGeneration, {jsonType: ConversationGenerationJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 14);

/**
 * Conversation is a character chat session. The caller identity is read from the
 * request context; conversations are scoped to that user.
 *
 * @generated from message creativefabrica.studioagent.v1.Conversation
 */
export type Conversation = Message$1<"creativefabrica.studioagent.v1.Conversation"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string agent_id = 3;
   */
  agentId: string;

  /**
   * @generated from field: string character_id = 4;
   */
  characterId: string;

  /**
   * @generated from field: string title = 5;
   */
  title: string;

  /**
   * @generated from field: bool title_is_custom = 6;
   */
  titleIsCustom: boolean;

  /**
   * @generated from field: string model = 7;
   */
  model: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.ConversationStatus status = 8;
   */
  status: ConversationStatus;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: Timestamp | undefined;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: Timestamp | undefined;

  /**
   * @generated from field: string last_message_snippet = 11;
   */
  lastMessageSnippet: string;

  /**
   * roleplay_state is the current mutable state (outfit / location / mood).
   *
   * @generated from field: map<string, string> roleplay_state = 12;
   */
  roleplayState: { [key: string]: string };

  /**
   * busy is true while a turn is in flight (busy lease live); the FE disables
   * the composer. Set on reload too.
   *
   * @generated from field: bool busy = 13;
   */
  busy: boolean;

  /**
   * active_message_id is the in-flight (thinking) assistant message when busy.
   *
   * @generated from field: optional string active_message_id = 14;
   */
  activeMessageId?: string | undefined;

  /**
   * Product surface selected when the conversation was created. It scopes
   * model availability and coin attribution for the conversation lifetime.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 15;
   */
  surface: Surface;

  /**
   * pending_action_message_id identifies the single assistant action currently
   * awaiting approval. It is absent when the conversation is unblocked.
   *
   * @generated from field: optional string pending_action_message_id = 16;
   */
  pendingActionMessageId?: string | undefined;
};

/**
 * Conversation is a character chat session. The caller identity is read from the
 * request context; conversations are scoped to that user.
 *
 * @generated from message creativefabrica.studioagent.v1.Conversation
 */
export type ConversationJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId?: string;

  /**
   * @generated from field: string agent_id = 3;
   */
  agentId?: string;

  /**
   * @generated from field: string character_id = 4;
   */
  characterId?: string;

  /**
   * @generated from field: string title = 5;
   */
  title?: string;

  /**
   * @generated from field: bool title_is_custom = 6;
   */
  titleIsCustom?: boolean;

  /**
   * @generated from field: string model = 7;
   */
  model?: string;

  /**
   * @generated from field: creativefabrica.studioagent.v1.ConversationStatus status = 8;
   */
  status?: ConversationStatusJson;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 9;
   */
  createdAt?: TimestampJson;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 10;
   */
  updatedAt?: TimestampJson;

  /**
   * @generated from field: string last_message_snippet = 11;
   */
  lastMessageSnippet?: string;

  /**
   * roleplay_state is the current mutable state (outfit / location / mood).
   *
   * @generated from field: map<string, string> roleplay_state = 12;
   */
  roleplayState?: { [key: string]: string };

  /**
   * busy is true while a turn is in flight (busy lease live); the FE disables
   * the composer. Set on reload too.
   *
   * @generated from field: bool busy = 13;
   */
  busy?: boolean;

  /**
   * active_message_id is the in-flight (thinking) assistant message when busy.
   *
   * @generated from field: optional string active_message_id = 14;
   */
  activeMessageId?: string;

  /**
   * Product surface selected when the conversation was created. It scopes
   * model availability and coin attribution for the conversation lifetime.
   *
   * @generated from field: creativefabrica.common.v1.surface.v1.Surface surface = 15;
   */
  surface?: SurfaceJson;

  /**
   * pending_action_message_id identifies the single assistant action currently
   * awaiting approval. It is absent when the conversation is unblocked.
   *
   * @generated from field: optional string pending_action_message_id = 16;
   */
  pendingActionMessageId?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.Conversation.
 * Use `create(ConversationSchema)` to create a new message.
 */
export const ConversationSchema: GenMessage<Conversation, {jsonType: ConversationJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 15);

/**
 * ModelOption is a selectable chat model and its per-message coin price.
 *
 * @generated from message creativefabrica.studioagent.v1.ModelOption
 */
export type ModelOption = Message$1<"creativefabrica.studioagent.v1.ModelOption"> & {
  /**
   * @generated from field: string model = 1;
   */
  model: string;

  /**
   * coins_per_msg is the flat coin price of one chat turn. 0 means chat turns
   * are free for this agent; generations it proposes are priced separately on
   * the approval card (MessageAction.quoted_coin_amount).
   *
   * @generated from field: int64 coins_per_msg = 2;
   */
  coinsPerMsg: bigint;
};

/**
 * ModelOption is a selectable chat model and its per-message coin price.
 *
 * @generated from message creativefabrica.studioagent.v1.ModelOption
 */
export type ModelOptionJson = {
  /**
   * @generated from field: string model = 1;
   */
  model?: string;

  /**
   * coins_per_msg is the flat coin price of one chat turn. 0 means chat turns
   * are free for this agent; generations it proposes are priced separately on
   * the approval card (MessageAction.quoted_coin_amount).
   *
   * @generated from field: int64 coins_per_msg = 2;
   */
  coinsPerMsg?: string;
};

/**
 * Describes the message creativefabrica.studioagent.v1.ModelOption.
 * Use `create(ModelOptionSchema)` to create a new message.
 */
export const ModelOptionSchema: GenMessage<ModelOption, {jsonType: ModelOptionJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 16);

/**
 * Agent is a configured agent type (the MVP ships one: character_chat).
 *
 * @generated from message creativefabrica.studioagent.v1.Agent
 */
export type Agent = Message$1<"creativefabrica.studioagent.v1.Agent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName: string;

  /**
   * @generated from field: bool requires_character = 3;
   */
  requiresCharacter: boolean;

  /**
   * @generated from field: string default_model = 4;
   */
  defaultModel: string;

  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.ModelOption models = 5;
   */
  models: ModelOption[];

  /**
   * Product surfaces on which this agent can create conversations. Configured
   * agents expose at least one supported surface.
   *
   * @generated from field: repeated creativefabrica.common.v1.surface.v1.Surface surfaces = 6;
   */
  surfaces: Surface[];

  /**
   * Tag 6 was already shipped as surfaces, so input_media intentionally uses
   * tag 7 rather than the originally proposed tag 6. It is absent for agents
   * that do not accept public uploads or reusable generated outputs.
   *
   * @generated from field: optional creativefabrica.studioagent.v1.AgentInputMediaCapabilities input_media = 7;
   */
  inputMedia?: AgentInputMediaCapabilities | undefined;

  /**
   * expression_cues lists every cue this agent may emit in
   * Message.expression, in registry order. Empty for agents that emit no
   * visual cues. Clients verify their mascot mapping against this list.
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.ExpressionCue expression_cues = 8;
   */
  expressionCues: ExpressionCue[];

  /**
   * concurrent_generations is true when the agent keeps accepting chat turns
   * and further proposals while its generations are still running; clients
   * keep the composer enabled and read in-flight work from the conversation's
   * generations rather than from Conversation.busy.
   *
   * @generated from field: bool concurrent_generations = 9;
   */
  concurrentGenerations: boolean;

  /**
   * requires_subscription is true when CreateConversation refuses callers
   * without an active Studio AI subscription for this agent. Clients can show
   * the upsell before creating a conversation instead of handling the error.
   *
   * @generated from field: bool requires_subscription = 10;
   */
  requiresSubscription: boolean;
};

/**
 * Agent is a configured agent type (the MVP ships one: character_chat).
 *
 * @generated from message creativefabrica.studioagent.v1.Agent
 */
export type AgentJson = {
  /**
   * @generated from field: string id = 1;
   */
  id?: string;

  /**
   * @generated from field: string display_name = 2;
   */
  displayName?: string;

  /**
   * @generated from field: bool requires_character = 3;
   */
  requiresCharacter?: boolean;

  /**
   * @generated from field: string default_model = 4;
   */
  defaultModel?: string;

  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.ModelOption models = 5;
   */
  models?: ModelOptionJson[];

  /**
   * Product surfaces on which this agent can create conversations. Configured
   * agents expose at least one supported surface.
   *
   * @generated from field: repeated creativefabrica.common.v1.surface.v1.Surface surfaces = 6;
   */
  surfaces?: SurfaceJson[];

  /**
   * Tag 6 was already shipped as surfaces, so input_media intentionally uses
   * tag 7 rather than the originally proposed tag 6. It is absent for agents
   * that do not accept public uploads or reusable generated outputs.
   *
   * @generated from field: optional creativefabrica.studioagent.v1.AgentInputMediaCapabilities input_media = 7;
   */
  inputMedia?: AgentInputMediaCapabilitiesJson;

  /**
   * expression_cues lists every cue this agent may emit in
   * Message.expression, in registry order. Empty for agents that emit no
   * visual cues. Clients verify their mascot mapping against this list.
   *
   * @generated from field: repeated creativefabrica.studioagent.v1.ExpressionCue expression_cues = 8;
   */
  expressionCues?: ExpressionCueJson[];

  /**
   * concurrent_generations is true when the agent keeps accepting chat turns
   * and further proposals while its generations are still running; clients
   * keep the composer enabled and read in-flight work from the conversation's
   * generations rather than from Conversation.busy.
   *
   * @generated from field: bool concurrent_generations = 9;
   */
  concurrentGenerations?: boolean;

  /**
   * requires_subscription is true when CreateConversation refuses callers
   * without an active Studio AI subscription for this agent. Clients can show
   * the upsell before creating a conversation instead of handling the error.
   *
   * @generated from field: bool requires_subscription = 10;
   */
  requiresSubscription?: boolean;
};

/**
 * Describes the message creativefabrica.studioagent.v1.Agent.
 * Use `create(AgentSchema)` to create a new message.
 */
export const AgentSchema: GenMessage<Agent, {jsonType: AgentJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 17);

/**
 * AgentInputMediaCapabilities exposes the reusable input sources and media
 * types enabled for an agent by configuration.
 *
 * @generated from message creativefabrica.studioagent.v1.AgentInputMediaCapabilities
 */
export type AgentInputMediaCapabilities = Message$1<"creativefabrica.studioagent.v1.AgentInputMediaCapabilities"> & {
  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.AgentInputMediaSource sources = 1;
   */
  sources: AgentInputMediaSource[];

  /**
   * @generated from field: repeated creativefabrica.modality.v1.MediaType media_types = 2;
   */
  mediaTypes: MediaType[];
};

/**
 * AgentInputMediaCapabilities exposes the reusable input sources and media
 * types enabled for an agent by configuration.
 *
 * @generated from message creativefabrica.studioagent.v1.AgentInputMediaCapabilities
 */
export type AgentInputMediaCapabilitiesJson = {
  /**
   * @generated from field: repeated creativefabrica.studioagent.v1.AgentInputMediaSource sources = 1;
   */
  sources?: AgentInputMediaSourceJson[];

  /**
   * @generated from field: repeated creativefabrica.modality.v1.MediaType media_types = 2;
   */
  mediaTypes?: MediaTypeJson[];
};

/**
 * Describes the message creativefabrica.studioagent.v1.AgentInputMediaCapabilities.
 * Use `create(AgentInputMediaCapabilitiesSchema)` to create a new message.
 */
export const AgentInputMediaCapabilitiesSchema: GenMessage<AgentInputMediaCapabilities, {jsonType: AgentInputMediaCapabilitiesJson}> = /*@__PURE__*/
  messageDesc(file_creativefabrica_studioagent_v1_types, 18);

/**
 * MessageRole is the author of a conversation message.
 *
 * @generated from enum creativefabrica.studioagent.v1.MessageRole
 */
export enum MessageRole {
  /**
   * @generated from enum value: MESSAGE_ROLE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MESSAGE_ROLE_USER = 1;
   */
  USER = 1,

  /**
   * @generated from enum value: MESSAGE_ROLE_ASSISTANT = 2;
   */
  ASSISTANT = 2,
}

/**
 * MessageRole is the author of a conversation message.
 *
 * @generated from enum creativefabrica.studioagent.v1.MessageRole
 */
export type MessageRoleJson = "MESSAGE_ROLE_UNSPECIFIED" | "MESSAGE_ROLE_USER" | "MESSAGE_ROLE_ASSISTANT";

/**
 * Describes the enum creativefabrica.studioagent.v1.MessageRole.
 */
export const MessageRoleSchema: GenEnum<MessageRole, MessageRoleJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studioagent_v1_types, 0);

/**
 * MessageStatus is the lifecycle state of an assistant message. In the MVP an
 * assistant message goes THINKING -> COMPLETE (or FAILED) directly; STREAMING is
 * reserved for a future streaming transport.
 *
 * @generated from enum creativefabrica.studioagent.v1.MessageStatus
 */
export enum MessageStatus {
  /**
   * @generated from enum value: MESSAGE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MESSAGE_STATUS_THINKING = 1;
   */
  THINKING = 1,

  /**
   * @generated from enum value: MESSAGE_STATUS_STREAMING = 2;
   */
  STREAMING = 2,

  /**
   * @generated from enum value: MESSAGE_STATUS_COMPLETE = 3;
   */
  COMPLETE = 3,

  /**
   * @generated from enum value: MESSAGE_STATUS_FAILED = 4;
   */
  FAILED = 4,
}

/**
 * MessageStatus is the lifecycle state of an assistant message. In the MVP an
 * assistant message goes THINKING -> COMPLETE (or FAILED) directly; STREAMING is
 * reserved for a future streaming transport.
 *
 * @generated from enum creativefabrica.studioagent.v1.MessageStatus
 */
export type MessageStatusJson = "MESSAGE_STATUS_UNSPECIFIED" | "MESSAGE_STATUS_THINKING" | "MESSAGE_STATUS_STREAMING" | "MESSAGE_STATUS_COMPLETE" | "MESSAGE_STATUS_FAILED";

/**
 * Describes the enum creativefabrica.studioagent.v1.MessageStatus.
 */
export const MessageStatusSchema: GenEnum<MessageStatus, MessageStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studioagent_v1_types, 1);

/**
 * ConversationStatus is the lifecycle state of a conversation.
 *
 * @generated from enum creativefabrica.studioagent.v1.ConversationStatus
 */
export enum ConversationStatus {
  /**
   * @generated from enum value: CONVERSATION_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CONVERSATION_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: CONVERSATION_STATUS_ARCHIVED = 2;
   */
  ARCHIVED = 2,
}

/**
 * ConversationStatus is the lifecycle state of a conversation.
 *
 * @generated from enum creativefabrica.studioagent.v1.ConversationStatus
 */
export type ConversationStatusJson = "CONVERSATION_STATUS_UNSPECIFIED" | "CONVERSATION_STATUS_ACTIVE" | "CONVERSATION_STATUS_ARCHIVED";

/**
 * Describes the enum creativefabrica.studioagent.v1.ConversationStatus.
 */
export const ConversationStatusSchema: GenEnum<ConversationStatus, ConversationStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studioagent_v1_types, 2);

/**
 * SendMessageStatus is the acknowledgement outcome of SendMessage.
 *
 * @generated from enum creativefabrica.studioagent.v1.SendMessageStatus
 */
export enum SendMessageStatus {
  /**
   * @generated from enum value: SEND_MESSAGE_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: SEND_MESSAGE_STATUS_ACCEPTED = 1;
   */
  ACCEPTED = 1,

  /**
   * @generated from enum value: SEND_MESSAGE_STATUS_REJECTED = 2;
   */
  REJECTED = 2,
}

/**
 * SendMessageStatus is the acknowledgement outcome of SendMessage.
 *
 * @generated from enum creativefabrica.studioagent.v1.SendMessageStatus
 */
export type SendMessageStatusJson = "SEND_MESSAGE_STATUS_UNSPECIFIED" | "SEND_MESSAGE_STATUS_ACCEPTED" | "SEND_MESSAGE_STATUS_REJECTED";

/**
 * Describes the enum creativefabrica.studioagent.v1.SendMessageStatus.
 */
export const SendMessageStatusSchema: GenEnum<SendMessageStatus, SendMessageStatusJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studioagent_v1_types, 3);

/**
 * CharacterMediaType selects the kind of media GenerateCharacterMedia produces,
 * which maps to the configured model per agent (image -> Seedream, video ->
 * Seedance).
 *
 * @generated from enum creativefabrica.studioagent.v1.CharacterMediaType
 */
export enum CharacterMediaType {
  /**
   * @generated from enum value: CHARACTER_MEDIA_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: CHARACTER_MEDIA_TYPE_IMAGE = 1;
   */
  IMAGE = 1,

  /**
   * @generated from enum value: CHARACTER_MEDIA_TYPE_VIDEO = 2;
   */
  VIDEO = 2,
}

/**
 * CharacterMediaType selects the kind of media GenerateCharacterMedia produces,
 * which maps to the configured model per agent (image -> Seedream, video ->
 * Seedance).
 *
 * @generated from enum creativefabrica.studioagent.v1.CharacterMediaType
 */
export type CharacterMediaTypeJson = "CHARACTER_MEDIA_TYPE_UNSPECIFIED" | "CHARACTER_MEDIA_TYPE_IMAGE" | "CHARACTER_MEDIA_TYPE_VIDEO";

/**
 * Describes the enum creativefabrica.studioagent.v1.CharacterMediaType.
 */
export const CharacterMediaTypeSchema: GenEnum<CharacterMediaType, CharacterMediaTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studioagent_v1_types, 4);

/**
 * MessageType distinguishes what a message carries: a chat/action turn or the
 * separate media message created after a generation action is approved.
 * Unspecified reads as chat for messages persisted before the field.
 *
 * @generated from enum creativefabrica.studioagent.v1.MessageType
 */
export enum MessageType {
  /**
   * @generated from enum value: MESSAGE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MESSAGE_TYPE_CHAT = 1;
   */
  CHAT = 1,

  /**
   * @generated from enum value: MESSAGE_TYPE_MEDIA = 2;
   */
  MEDIA = 2,
}

/**
 * MessageType distinguishes what a message carries: a chat/action turn or the
 * separate media message created after a generation action is approved.
 * Unspecified reads as chat for messages persisted before the field.
 *
 * @generated from enum creativefabrica.studioagent.v1.MessageType
 */
export type MessageTypeJson = "MESSAGE_TYPE_UNSPECIFIED" | "MESSAGE_TYPE_CHAT" | "MESSAGE_TYPE_MEDIA";

/**
 * Describes the enum creativefabrica.studioagent.v1.MessageType.
 */
export const MessageTypeSchema: GenEnum<MessageType, MessageTypeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studioagent_v1_types, 5);

/**
 * MessageActionState is the lifecycle state of an approval action shown on an
 * assistant message.
 *
 * @generated from enum creativefabrica.studioagent.v1.MessageActionState
 */
export enum MessageActionState {
  /**
   * @generated from enum value: MESSAGE_ACTION_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MESSAGE_ACTION_STATE_AWAITING_APPROVAL = 1;
   */
  AWAITING_APPROVAL = 1,

  /**
   * @generated from enum value: MESSAGE_ACTION_STATE_APPROVED = 2;
   */
  APPROVED = 2,

  /**
   * @generated from enum value: MESSAGE_ACTION_STATE_REJECTED = 3;
   */
  REJECTED = 3,
}

/**
 * MessageActionState is the lifecycle state of an approval action shown on an
 * assistant message.
 *
 * @generated from enum creativefabrica.studioagent.v1.MessageActionState
 */
export type MessageActionStateJson = "MESSAGE_ACTION_STATE_UNSPECIFIED" | "MESSAGE_ACTION_STATE_AWAITING_APPROVAL" | "MESSAGE_ACTION_STATE_APPROVED" | "MESSAGE_ACTION_STATE_REJECTED";

/**
 * Describes the enum creativefabrica.studioagent.v1.MessageActionState.
 */
export const MessageActionStateSchema: GenEnum<MessageActionState, MessageActionStateJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studioagent_v1_types, 6);

/**
 * MessageActionRejectionReason explains why an approval action was rejected.
 *
 * @generated from enum creativefabrica.studioagent.v1.MessageActionRejectionReason
 */
export enum MessageActionRejectionReason {
  /**
   * @generated from enum value: MESSAGE_ACTION_REJECTION_REASON_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: MESSAGE_ACTION_REJECTION_REASON_USER_REJECTED = 1;
   */
  USER_REJECTED = 1,

  /**
   * @generated from enum value: MESSAGE_ACTION_REJECTION_REASON_INSUFFICIENT_BALANCE = 2;
   */
  INSUFFICIENT_BALANCE = 2,

  /**
   * The frozen request became invalid or otherwise unavailable before it
   * could be dispatched.
   *
   * @generated from enum value: MESSAGE_ACTION_REJECTION_REASON_REQUEST_UNAVAILABLE = 3;
   */
  REQUEST_UNAVAILABLE = 3,

  /**
   * The user sent a new message instead of deciding, so the pending action
   * was closed automatically (agents configured to supersede pending actions).
   *
   * @generated from enum value: MESSAGE_ACTION_REJECTION_REASON_SUPERSEDED = 4;
   */
  SUPERSEDED = 4,

  /**
   * The charge behind the approval requires an AI Studio subscription the
   * user does not have. Chat may be free for the agent, so the card can be
   * the first point where the entitlement matters. MessageAction.rejection_error
   * carries the coins detail.
   *
   * @generated from enum value: MESSAGE_ACTION_REJECTION_REASON_SUBSCRIPTION_REQUIRED = 5;
   */
  SUBSCRIPTION_REQUIRED = 5,

  /**
   * The coins service needs a payment step (for example a trial activation)
   * before it can charge. MessageAction.rejection_error carries the detail,
   * including any payment intent.
   *
   * @generated from enum value: MESSAGE_ACTION_REJECTION_REASON_PAYMENT_REQUIRED = 6;
   */
  PAYMENT_REQUIRED = 6,
}

/**
 * MessageActionRejectionReason explains why an approval action was rejected.
 *
 * @generated from enum creativefabrica.studioagent.v1.MessageActionRejectionReason
 */
export type MessageActionRejectionReasonJson = "MESSAGE_ACTION_REJECTION_REASON_UNSPECIFIED" | "MESSAGE_ACTION_REJECTION_REASON_USER_REJECTED" | "MESSAGE_ACTION_REJECTION_REASON_INSUFFICIENT_BALANCE" | "MESSAGE_ACTION_REJECTION_REASON_REQUEST_UNAVAILABLE" | "MESSAGE_ACTION_REJECTION_REASON_SUPERSEDED" | "MESSAGE_ACTION_REJECTION_REASON_SUBSCRIPTION_REQUIRED" | "MESSAGE_ACTION_REJECTION_REASON_PAYMENT_REQUIRED";

/**
 * Describes the enum creativefabrica.studioagent.v1.MessageActionRejectionReason.
 */
export const MessageActionRejectionReasonSchema: GenEnum<MessageActionRejectionReason, MessageActionRejectionReasonJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studioagent_v1_types, 7);

/**
 * AgentInputMediaSource is a reusable input source an agent may accept.
 *
 * @generated from enum creativefabrica.studioagent.v1.AgentInputMediaSource
 */
export enum AgentInputMediaSource {
  /**
   * @generated from enum value: AGENT_INPUT_MEDIA_SOURCE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: AGENT_INPUT_MEDIA_SOURCE_USER_UPLOAD = 1;
   */
  USER_UPLOAD = 1,

  /**
   * @generated from enum value: AGENT_INPUT_MEDIA_SOURCE_GENERATED_OUTPUT = 2;
   */
  GENERATED_OUTPUT = 2,

  /**
   * WEB_IMPORT is media the server fetched from a URL outside Creative Fabrica
   * (ImportWebMedia). Its InputRef carries a web_import block with the origin
   * and the fetch status.
   *
   * @generated from enum value: AGENT_INPUT_MEDIA_SOURCE_WEB_IMPORT = 3;
   */
  WEB_IMPORT = 3,
}

/**
 * AgentInputMediaSource is a reusable input source an agent may accept.
 *
 * @generated from enum creativefabrica.studioagent.v1.AgentInputMediaSource
 */
export type AgentInputMediaSourceJson = "AGENT_INPUT_MEDIA_SOURCE_UNSPECIFIED" | "AGENT_INPUT_MEDIA_SOURCE_USER_UPLOAD" | "AGENT_INPUT_MEDIA_SOURCE_GENERATED_OUTPUT" | "AGENT_INPUT_MEDIA_SOURCE_WEB_IMPORT";

/**
 * Describes the enum creativefabrica.studioagent.v1.AgentInputMediaSource.
 */
export const AgentInputMediaSourceSchema: GenEnum<AgentInputMediaSource, AgentInputMediaSourceJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studioagent_v1_types, 8);

/**
 * InputRefReadiness is the lifecycle state of a reusable conversation input.
 *
 * @generated from enum creativefabrica.studioagent.v1.InputRefReadiness
 */
export enum InputRefReadiness {
  /**
   * @generated from enum value: INPUT_REF_READINESS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: INPUT_REF_READINESS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * @generated from enum value: INPUT_REF_READINESS_READY = 2;
   */
  READY = 2,

  /**
   * @generated from enum value: INPUT_REF_READINESS_FAILED = 3;
   */
  FAILED = 3,
}

/**
 * InputRefReadiness is the lifecycle state of a reusable conversation input.
 *
 * @generated from enum creativefabrica.studioagent.v1.InputRefReadiness
 */
export type InputRefReadinessJson = "INPUT_REF_READINESS_UNSPECIFIED" | "INPUT_REF_READINESS_PENDING" | "INPUT_REF_READINESS_READY" | "INPUT_REF_READINESS_FAILED";

/**
 * Describes the enum creativefabrica.studioagent.v1.InputRefReadiness.
 */
export const InputRefReadinessSchema: GenEnum<InputRefReadiness, InputRefReadinessJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studioagent_v1_types, 9);

/**
 * WebImportStage is how far the server has got fetching a web import. It
 * refines InputRefReadiness for display: QUEUED, DOWNLOADING and VERIFYING
 * are all PENDING.
 *
 * @generated from enum creativefabrica.studioagent.v1.WebImportStage
 */
export enum WebImportStage {
  /**
   * @generated from enum value: WEB_IMPORT_STAGE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * QUEUED: waiting for a worker or connecting to the origin.
   *
   * @generated from enum value: WEB_IMPORT_STAGE_QUEUED = 1;
   */
  QUEUED = 1,

  /**
   * @generated from enum value: WEB_IMPORT_STAGE_DOWNLOADING = 2;
   */
  DOWNLOADING = 2,

  /**
   * VERIFYING: the file is stored and its type, size and duration are being
   * checked.
   *
   * @generated from enum value: WEB_IMPORT_STAGE_VERIFYING = 3;
   */
  VERIFYING = 3,

  /**
   * READY: readiness is READY.
   *
   * @generated from enum value: WEB_IMPORT_STAGE_READY = 4;
   */
  READY = 4,

  /**
   * FAILED: readiness is FAILED; WebImport.failure says why.
   *
   * @generated from enum value: WEB_IMPORT_STAGE_FAILED = 5;
   */
  FAILED = 5,
}

/**
 * WebImportStage is how far the server has got fetching a web import. It
 * refines InputRefReadiness for display: QUEUED, DOWNLOADING and VERIFYING
 * are all PENDING.
 *
 * @generated from enum creativefabrica.studioagent.v1.WebImportStage
 */
export type WebImportStageJson = "WEB_IMPORT_STAGE_UNSPECIFIED" | "WEB_IMPORT_STAGE_QUEUED" | "WEB_IMPORT_STAGE_DOWNLOADING" | "WEB_IMPORT_STAGE_VERIFYING" | "WEB_IMPORT_STAGE_READY" | "WEB_IMPORT_STAGE_FAILED";

/**
 * Describes the enum creativefabrica.studioagent.v1.WebImportStage.
 */
export const WebImportStageSchema: GenEnum<WebImportStage, WebImportStageJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studioagent_v1_types, 10);

/**
 * WebImportFailure is why a web import failed.
 *
 * @generated from enum creativefabrica.studioagent.v1.WebImportFailure
 */
export enum WebImportFailure {
  /**
   * @generated from enum value: WEB_IMPORT_FAILURE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * BLOCKED_HOST: the URL resolves or redirects to a private, loopback,
   * link-local or metadata address.
   *
   * @generated from enum value: WEB_IMPORT_FAILURE_BLOCKED_HOST = 1;
   */
  BLOCKED_HOST = 1,

  /**
   * UNSUPPORTED_TYPE: the bytes are not a PNG, JPEG, WebP, GIF, MP4, MOV or
   * WebM file, or the agent does not take that media type.
   *
   * @generated from enum value: WEB_IMPORT_FAILURE_UNSUPPORTED_TYPE = 2;
   */
  UNSUPPORTED_TYPE = 2,

  /**
   * PAGE_OR_STREAM: the URL is a web page (for example a YouTube or TikTok
   * link) or an HLS/DASH stream, not a media file.
   *
   * @generated from enum value: WEB_IMPORT_FAILURE_PAGE_OR_STREAM = 3;
   */
  PAGE_OR_STREAM = 3,

  /**
   * @generated from enum value: WEB_IMPORT_FAILURE_TOO_LARGE = 4;
   */
  TOO_LARGE = 4,

  /**
   * TOO_LONG: the video is longer than the import limit.
   *
   * @generated from enum value: WEB_IMPORT_FAILURE_TOO_LONG = 5;
   */
  TOO_LONG = 5,

  /**
   * FETCH_FAILED: DNS, connection, TLS or a non-2xx answer from the origin
   * (including hotlink protection), or too many redirects.
   *
   * @generated from enum value: WEB_IMPORT_FAILURE_FETCH_FAILED = 6;
   */
  FETCH_FAILED = 6,

  /**
   * TIMEOUT: the download took too long, or the import expired before a
   * worker finished it.
   *
   * @generated from enum value: WEB_IMPORT_FAILURE_TIMEOUT = 7;
   */
  TIMEOUT = 7,
}

/**
 * WebImportFailure is why a web import failed.
 *
 * @generated from enum creativefabrica.studioagent.v1.WebImportFailure
 */
export type WebImportFailureJson = "WEB_IMPORT_FAILURE_UNSPECIFIED" | "WEB_IMPORT_FAILURE_BLOCKED_HOST" | "WEB_IMPORT_FAILURE_UNSUPPORTED_TYPE" | "WEB_IMPORT_FAILURE_PAGE_OR_STREAM" | "WEB_IMPORT_FAILURE_TOO_LARGE" | "WEB_IMPORT_FAILURE_TOO_LONG" | "WEB_IMPORT_FAILURE_FETCH_FAILED" | "WEB_IMPORT_FAILURE_TIMEOUT";

/**
 * Describes the enum creativefabrica.studioagent.v1.WebImportFailure.
 */
export const WebImportFailureSchema: GenEnum<WebImportFailure, WebImportFailureJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studioagent_v1_types, 11);

/**
 * ExpressionCue is the mascot face registry, mirroring the Studio helper's
 * procedural pose set one-to-one. The model chooses one reaction face per
 * assistant message (Agent.expression_cues lists which ones an agent may
 * emit); RELAXED, ATTENTIVE, THINKING, SPEAKING, HEARTBEAT and REVEAL also
 * exist as client-driven states. UNSPECIFIED means neutral (no cue).
 * Presentation only: a cue never asserts that any action happened. proto3
 * enums are open, so clients built against an older schema receive a bare
 * number for a newer value and must treat it as neutral.
 *
 * @generated from enum creativefabrica.studioagent.v1.ExpressionCue
 */
export enum ExpressionCue {
  /**
   * @generated from enum value: EXPRESSION_CUE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: EXPRESSION_CUE_FOCUSED = 1;
   */
  FOCUSED = 1,

  /**
   * @generated from enum value: EXPRESSION_CUE_CONFIDENT = 2;
   */
  CONFIDENT = 2,

  /**
   * @generated from enum value: EXPRESSION_CUE_AMUSED = 3;
   */
  AMUSED = 3,

  /**
   * @generated from enum value: EXPRESSION_CUE_HEARTBEAT = 4;
   */
  HEARTBEAT = 4,

  /**
   * @generated from enum value: EXPRESSION_CUE_REVEAL = 5;
   */
  REVEAL = 5,

  /**
   * @generated from enum value: EXPRESSION_CUE_RELAXED = 6;
   */
  RELAXED = 6,

  /**
   * @generated from enum value: EXPRESSION_CUE_ATTENTIVE = 7;
   */
  ATTENTIVE = 7,

  /**
   * @generated from enum value: EXPRESSION_CUE_CURIOUS = 8;
   */
  CURIOUS = 8,

  /**
   * @generated from enum value: EXPRESSION_CUE_THINKING = 9;
   */
  THINKING = 9,

  /**
   * @generated from enum value: EXPRESSION_CUE_SPEAKING = 10;
   */
  SPEAKING = 10,

  /**
   * @generated from enum value: EXPRESSION_CUE_DELIGHTED = 11;
   */
  DELIGHTED = 11,

  /**
   * @generated from enum value: EXPRESSION_CUE_SURPRISED = 12;
   */
  SURPRISED = 12,

  /**
   * @generated from enum value: EXPRESSION_CUE_UNSURE = 13;
   */
  UNSURE = 13,

  /**
   * @generated from enum value: EXPRESSION_CUE_REASSURING = 14;
   */
  REASSURING = 14,
}

/**
 * ExpressionCue is the mascot face registry, mirroring the Studio helper's
 * procedural pose set one-to-one. The model chooses one reaction face per
 * assistant message (Agent.expression_cues lists which ones an agent may
 * emit); RELAXED, ATTENTIVE, THINKING, SPEAKING, HEARTBEAT and REVEAL also
 * exist as client-driven states. UNSPECIFIED means neutral (no cue).
 * Presentation only: a cue never asserts that any action happened. proto3
 * enums are open, so clients built against an older schema receive a bare
 * number for a newer value and must treat it as neutral.
 *
 * @generated from enum creativefabrica.studioagent.v1.ExpressionCue
 */
export type ExpressionCueJson = "EXPRESSION_CUE_UNSPECIFIED" | "EXPRESSION_CUE_FOCUSED" | "EXPRESSION_CUE_CONFIDENT" | "EXPRESSION_CUE_AMUSED" | "EXPRESSION_CUE_HEARTBEAT" | "EXPRESSION_CUE_REVEAL" | "EXPRESSION_CUE_RELAXED" | "EXPRESSION_CUE_ATTENTIVE" | "EXPRESSION_CUE_CURIOUS" | "EXPRESSION_CUE_THINKING" | "EXPRESSION_CUE_SPEAKING" | "EXPRESSION_CUE_DELIGHTED" | "EXPRESSION_CUE_SURPRISED" | "EXPRESSION_CUE_UNSURE" | "EXPRESSION_CUE_REASSURING";

/**
 * Describes the enum creativefabrica.studioagent.v1.ExpressionCue.
 */
export const ExpressionCueSchema: GenEnum<ExpressionCue, ExpressionCueJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studioagent_v1_types, 12);

/**
 * AgentQuestionKind says what a question's options stand for.
 *
 * @generated from enum creativefabrica.studioagent.v1.AgentQuestionKind
 */
export enum AgentQuestionKind {
  /**
   * A generic question: plain label chips, empty option values.
   *
   * @generated from enum value: AGENT_QUESTION_KIND_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * What the user wants to make: output type, purpose, style or tone.
   *
   * @generated from enum value: AGENT_QUESTION_KIND_INTENT = 1;
   */
  INTENT = 1,

  /**
   * Which model to use: each option's value is a model id from the agent's
   * catalog (an option for "let the agent choose" has an empty value). The
   * options list every model that fits the request; the agent's picks are
   * marked suggested. A picked model, suggested or from the rest of the list,
   * is answered with its label (catalog names of models are unique).
   *
   * @generated from enum value: AGENT_QUESTION_KIND_MODEL = 2;
   */
  MODEL = 2,

  /**
   * Which voice to use: AgentQuestion.voice_catalog names the catalog to
   * choose from; each option (if any) is a suggested voice whose value is its
   * voice id and preview_url its audition clip.
   *
   * @generated from enum value: AGENT_QUESTION_KIND_VOICE = 3;
   */
  VOICE = 3,
}

/**
 * AgentQuestionKind says what a question's options stand for.
 *
 * @generated from enum creativefabrica.studioagent.v1.AgentQuestionKind
 */
export type AgentQuestionKindJson = "AGENT_QUESTION_KIND_UNSPECIFIED" | "AGENT_QUESTION_KIND_INTENT" | "AGENT_QUESTION_KIND_MODEL" | "AGENT_QUESTION_KIND_VOICE";

/**
 * Describes the enum creativefabrica.studioagent.v1.AgentQuestionKind.
 */
export const AgentQuestionKindSchema: GenEnum<AgentQuestionKind, AgentQuestionKindJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studioagent_v1_types, 13);

/**
 * Tool identifies one of the generation agents' callable tools. Adding a new
 * genai-backed tool is a one-line extension here; proto3 enums are open, so
 * clients built against an older schema receive the new value without
 * breaking and should render unknown tools generically.
 *
 * @generated from enum creativefabrica.studioagent.v1.Tool
 */
export enum Tool {
  /**
   * @generated from enum value: TOOL_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TOOL_LIST_MODELS = 1;
   */
  LIST_MODELS = 1,

  /**
   * @generated from enum value: TOOL_GET_MODEL_DETAILS = 2;
   */
  GET_MODEL_DETAILS = 2,

  /**
   * @generated from enum value: TOOL_GENERATE = 3;
   */
  GENERATE = 3,

  /**
   * @generated from enum value: TOOL_GET_GENERATION_STATUS = 4;
   */
  GET_GENERATION_STATUS = 4,

  /**
   * @generated from enum value: TOOL_LIST_REFS = 5;
   */
  LIST_REFS = 5,

  /**
   * Inspect a reusable input as actual multimodal content before choosing its
   * generation role (sourceImage, firstFrame, referenceVideo, etc.).
   *
   * @generated from enum value: TOOL_INSPECT_REF = 6;
   */
  INSPECT_REF = 6,

  /**
   * Price one model/modality/options/input combination in coins without
   * preparing a proposal; advisory, the approval card carries the final price.
   *
   * @generated from enum value: TOOL_ESTIMATE_COST = 7;
   */
  ESTIMATE_COST = 7,

  /**
   * List or narrow the speaker voices of a speech model's voice catalog, so
   * the agent proposes a real voice id instead of inventing one.
   *
   * @generated from enum value: TOOL_LIST_VOICES = 8;
   */
  LIST_VOICES = 8,

  /**
   * Choose the generation model for a request from its task, inputs and
   * requirements: the service, not the chat model, picks it, so the choice
   * does not depend on which chat model runs the conversation. The chosen
   * model is the one a following generate call may use.
   *
   * @generated from enum value: TOOL_CHOOSE_MODEL = 9;
   */
  CHOOSE_MODEL = 9,

  /**
   * Tell the user, in the agent's own words, what it is about to do before a
   * batch of tool calls. Presentation only; performs no action. The event's
   * summary carries the user-facing text, which clients render as an
   * assistant message rather than a tool line.
   *
   * @generated from enum value: TOOL_PROGRESS_UPDATE = 10;
   */
  PROGRESS_UPDATE = 10,
}

/**
 * Tool identifies one of the generation agents' callable tools. Adding a new
 * genai-backed tool is a one-line extension here; proto3 enums are open, so
 * clients built against an older schema receive the new value without
 * breaking and should render unknown tools generically.
 *
 * @generated from enum creativefabrica.studioagent.v1.Tool
 */
export type ToolJson = "TOOL_UNSPECIFIED" | "TOOL_LIST_MODELS" | "TOOL_GET_MODEL_DETAILS" | "TOOL_GENERATE" | "TOOL_GET_GENERATION_STATUS" | "TOOL_LIST_REFS" | "TOOL_INSPECT_REF" | "TOOL_ESTIMATE_COST" | "TOOL_LIST_VOICES" | "TOOL_CHOOSE_MODEL" | "TOOL_PROGRESS_UPDATE";

/**
 * Describes the enum creativefabrica.studioagent.v1.Tool.
 */
export const ToolSchema: GenEnum<Tool, ToolJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studioagent_v1_types, 14);

/**
 * ToolCallOutcome is the terminal result of one tool call.
 *
 * @generated from enum creativefabrica.studioagent.v1.ToolCallOutcome
 */
export enum ToolCallOutcome {
  /**
   * @generated from enum value: TOOL_CALL_OUTCOME_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TOOL_CALL_OUTCOME_OK = 1;
   */
  OK = 1,

  /**
   * @generated from enum value: TOOL_CALL_OUTCOME_ERROR = 2;
   */
  ERROR = 2,
}

/**
 * ToolCallOutcome is the terminal result of one tool call.
 *
 * @generated from enum creativefabrica.studioagent.v1.ToolCallOutcome
 */
export type ToolCallOutcomeJson = "TOOL_CALL_OUTCOME_UNSPECIFIED" | "TOOL_CALL_OUTCOME_OK" | "TOOL_CALL_OUTCOME_ERROR";

/**
 * Describes the enum creativefabrica.studioagent.v1.ToolCallOutcome.
 */
export const ToolCallOutcomeSchema: GenEnum<ToolCallOutcome, ToolCallOutcomeJson> = /*@__PURE__*/
  enumDesc(file_creativefabrica_studioagent_v1_types, 15);

